import { createInstance } from 'i18next';
import { DEFAULT_LOCALE } from '@honeybook/i18n';
import enUSHbui from './en-US/hbui.json';
import enGBHbui from './en-GB/hbui.json';
import enAUHbui from './en-AU/hbui.json';

const i18n = createInstance();

i18n.init({
    initImmediate: false, // synchronous — JSON files are bundled statically, no async plugins
    lng: DEFAULT_LOCALE,
    fallbackLng: DEFAULT_LOCALE,
    resources: {
        'en-US': { hbui: enUSHbui },
        'en-GB': { hbui: enGBHbui },
        'en-AU': { hbui: enAUHbui }
        // en-CA falls back to 'en-US' (fallbackLng) — same strings as US English
    },
    defaultNS: 'hbui',
    interpolation: { escapeValue: false }
});

export default i18n;
